import type { AttributeSelectionActions } from "../coachingGeneratorStore";

export const createAttributeSelectionActions = (set: any): AttributeSelectionActions => ({
  toggleAttribute: (attribute: string) =>
    set((state: any) => {
      const newSet = new Set(state.selectedAttributes);
      if (newSet.has(attribute)) {
        newSet.delete(attribute);
        return { selectedAttributes: newSet };
      }

      newSet.add(attribute);
      return { selectedAttributes: newSet };
    }),

  selectAllAttributes: (attributes: string[]) =>
    set((state: any) => {
      if (state.selectedAttributes.size === attributes.length) {
        return { selectedAttributes: new Set<string>() };
      }
      return { selectedAttributes: new Set(attributes) };
    }),

  clearSelectedAttributes: () => set({ selectedAttributes: new Set<string>() }),

  setExpandedAttribute: (attribute: string | null) =>
    set({ expandedAttribute: attribute })
});
